module.exports = __webpack_public_path__ + "static/media/Knobs_Metering.042d2767.png";